export default {
  type: 'user_roles',
  name: 'Users With Roles',
  description: 'User Search with Instrument Contacts and Roles',
  search: {
    search: 'allPeople',
    orderBy: {
      type: 'PeopleOrderBy',
      default: 'FULL_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        placeholder: 'Name / Address / Email / Affiliation / Etc.',
        searchOnly: true
      },
      {
        name: 'personId',
        searchable: false,
        order: 'PERSON_ID'
      },
      {
        name: 'fullName',
        label: 'Name',
        searchable: false,
        order: 'FULL_NAME'
      },
      {
        name: 'email',
        searchable: false,
        order: 'EMAIL'
      },
      {
        name: 'affiliation',
        searchable: false,
        order: 'AFFILIATION'
      },
      {
        name: 'creationTime',
        label: 'Registration Date',
        searchOnly: true,
        type: 'daterange'
      },
      [
        {
          name: 'statusCode',
          label: 'Status',
          type: 'select',
          order: 'STATUS_CODE',
          options: {
            lookup: 'allUserStatuses',
            value: 'statusCode',
            text: 'statusDesc',
            allowNull: true,
            nullText: 'All'
          },
          width: 6
        },
        {
          name: 'scienceUser',
          type: 'select',
          width: 6,
          fieldType: 'Boolean',
          order: 'SCIENCE_USER',
          options: [
            { value: null, text: 'Both' },
            { value: true, text: 'Yes' },
            { value: false, text: 'No' }
          ]
        }
      ],
      {
        name: 'countryCode',
        label: 'Country',
        searchOnly: true,
        type: 'select',
        options: {
          lookup: 'allCountries',
          value: 'countryCode',
          text: 'countryName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'CountriesOrderBy',
              default: 'COUNTRY_NAME_ASC'
            }
          ]
        }
      },
      {
        alias: 'roles',
        searchable: false,
        order: 'ROLE_NAME',
        join: 'rolePeopleByPersonId',
        nodes: true,
        fields: ['roleName'],
        separator: '<br />'
      },
      {
        name: 'instrumentClasses',
        searchable: false,
        resultType: 'arrayConcat',
        separator: '<br />'
      }
    ]
  }
}
